export default function ProgrammingIcon(
  props: Pick<React.SVGProps<SVGSVGElement>, "fill" | "fillOpacity">,
) {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.66849 10.0001L3.77599 15.8926L2.59766 14.7142L7.31182 10.0001L2.59766 5.2859L3.77599 4.1084L9.66849 10.0001ZM9.66849 15.8334H18.0018V17.5001H9.66849V15.8334Z"
        fill={props.fill || "#0F1324"}
        fillOpacity={props.fillOpacity || "0.6"}
      />
    </svg>
  );
}
